/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { WebhookEventCreateRequestBaseResponse as ModelsWebhookWebhookEventCreateRequestBaseResponse } from '../models/Models/Webhook/webhook-event-create-request-base-response';
import { WebhookEventNotificationResponseBaseBaseResponse as ModelsWebhookWebhookEventNotificationResponseBaseBaseResponse } from '../models/Models/Webhook/webhook-event-notification-response-base-base-response';
import { v4WebhooksCallbacktestPost$Json } from '../fn/webhooks/v-4-webhooks-callbacktest-post-json';
import { V4WebhooksCallbacktestPost$Json$Params } from '../fn/webhooks/v-4-webhooks-callbacktest-post-json';
import { v4WebhooksCallbacktestPost$Plain } from '../fn/webhooks/v-4-webhooks-callbacktest-post-plain';
import { V4WebhooksCallbacktestPost$Plain$Params } from '../fn/webhooks/v-4-webhooks-callbacktest-post-plain';
import { v4WebhooksDeregisterDelete$Json } from '../fn/webhooks/v-4-webhooks-deregister-delete-json';
import { V4WebhooksDeregisterDelete$Json$Params } from '../fn/webhooks/v-4-webhooks-deregister-delete-json';
import { v4WebhooksDeregisterDelete$Plain } from '../fn/webhooks/v-4-webhooks-deregister-delete-plain';
import { V4WebhooksDeregisterDelete$Plain$Params } from '../fn/webhooks/v-4-webhooks-deregister-delete-plain';
import { v4WebhooksDeregisterDelete$Xml } from '../fn/webhooks/v-4-webhooks-deregister-delete-xml';
import { V4WebhooksDeregisterDelete$Xml$Params } from '../fn/webhooks/v-4-webhooks-deregister-delete-xml';
import { v4WebhooksRegisterPost$Json$Json } from '../fn/webhooks/v-4-webhooks-register-post-json-json';
import { V4WebhooksRegisterPost$Json$Json$Params } from '../fn/webhooks/v-4-webhooks-register-post-json-json';
import { v4WebhooksRegisterPost$Json$Plain } from '../fn/webhooks/v-4-webhooks-register-post-json-plain';
import { V4WebhooksRegisterPost$Json$Plain$Params } from '../fn/webhooks/v-4-webhooks-register-post-json-plain';
import { v4WebhooksRegisterPost$Json$Xml } from '../fn/webhooks/v-4-webhooks-register-post-json-xml';
import { V4WebhooksRegisterPost$Json$Xml$Params } from '../fn/webhooks/v-4-webhooks-register-post-json-xml';
import { v4WebhooksRegisterPost$Xml$Json } from '../fn/webhooks/v-4-webhooks-register-post-xml-json';
import { V4WebhooksRegisterPost$Xml$Json$Params } from '../fn/webhooks/v-4-webhooks-register-post-xml-json';
import { v4WebhooksRegisterPost$Xml$Plain } from '../fn/webhooks/v-4-webhooks-register-post-xml-plain';
import { V4WebhooksRegisterPost$Xml$Plain$Params } from '../fn/webhooks/v-4-webhooks-register-post-xml-plain';
import { v4WebhooksRegisterPost$Xml$Xml } from '../fn/webhooks/v-4-webhooks-register-post-xml-xml';
import { V4WebhooksRegisterPost$Xml$Xml$Params } from '../fn/webhooks/v-4-webhooks-register-post-xml-xml';

@Injectable({ providedIn: 'root' })
export class WebhooksService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v4WebhooksRegisterPost()` */
  static readonly V4WebhooksRegisterPostPath = '/v4/webhooks/register';

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4WebhooksRegisterPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4WebhooksRegisterPost$Json$Plain$Response(params?: V4WebhooksRegisterPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
    return v4WebhooksRegisterPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4WebhooksRegisterPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4WebhooksRegisterPost$Json$Plain(params?: V4WebhooksRegisterPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventCreateRequestBaseResponse> {
    return this.v4WebhooksRegisterPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>): ModelsWebhookWebhookEventCreateRequestBaseResponse => r.body)
    );
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4WebhooksRegisterPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4WebhooksRegisterPost$Json$Json$Response(params?: V4WebhooksRegisterPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
    return v4WebhooksRegisterPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4WebhooksRegisterPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4WebhooksRegisterPost$Json$Json(params?: V4WebhooksRegisterPost$Json$Json$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventCreateRequestBaseResponse> {
    return this.v4WebhooksRegisterPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>): ModelsWebhookWebhookEventCreateRequestBaseResponse => r.body)
    );
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4WebhooksRegisterPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4WebhooksRegisterPost$Json$Xml$Response(params?: V4WebhooksRegisterPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
    return v4WebhooksRegisterPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4WebhooksRegisterPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4WebhooksRegisterPost$Json$Xml(params?: V4WebhooksRegisterPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventCreateRequestBaseResponse> {
    return this.v4WebhooksRegisterPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>): ModelsWebhookWebhookEventCreateRequestBaseResponse => r.body)
    );
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4WebhooksRegisterPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4WebhooksRegisterPost$Xml$Plain$Response(params?: V4WebhooksRegisterPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
    return v4WebhooksRegisterPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4WebhooksRegisterPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4WebhooksRegisterPost$Xml$Plain(params?: V4WebhooksRegisterPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventCreateRequestBaseResponse> {
    return this.v4WebhooksRegisterPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>): ModelsWebhookWebhookEventCreateRequestBaseResponse => r.body)
    );
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4WebhooksRegisterPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4WebhooksRegisterPost$Xml$Json$Response(params?: V4WebhooksRegisterPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
    return v4WebhooksRegisterPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4WebhooksRegisterPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4WebhooksRegisterPost$Xml$Json(params?: V4WebhooksRegisterPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventCreateRequestBaseResponse> {
    return this.v4WebhooksRegisterPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>): ModelsWebhookWebhookEventCreateRequestBaseResponse => r.body)
    );
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4WebhooksRegisterPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4WebhooksRegisterPost$Xml$Xml$Response(params?: V4WebhooksRegisterPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
    return v4WebhooksRegisterPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4WebhooksRegisterPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4WebhooksRegisterPost$Xml$Xml(params?: V4WebhooksRegisterPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventCreateRequestBaseResponse> {
    return this.v4WebhooksRegisterPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>): ModelsWebhookWebhookEventCreateRequestBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4WebhooksDeregisterDelete()` */
  static readonly V4WebhooksDeregisterDeletePath = '/v4/webhooks/deregister';

  /**
   * Deregister callback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4WebhooksDeregisterDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4WebhooksDeregisterDelete$Plain$Response(params?: V4WebhooksDeregisterDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
    return v4WebhooksDeregisterDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Deregister callback.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4WebhooksDeregisterDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4WebhooksDeregisterDelete$Plain(params?: V4WebhooksDeregisterDelete$Plain$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventCreateRequestBaseResponse> {
    return this.v4WebhooksDeregisterDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>): ModelsWebhookWebhookEventCreateRequestBaseResponse => r.body)
    );
  }

  /**
   * Deregister callback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4WebhooksDeregisterDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4WebhooksDeregisterDelete$Json$Response(params?: V4WebhooksDeregisterDelete$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
    return v4WebhooksDeregisterDelete$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Deregister callback.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4WebhooksDeregisterDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4WebhooksDeregisterDelete$Json(params?: V4WebhooksDeregisterDelete$Json$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventCreateRequestBaseResponse> {
    return this.v4WebhooksDeregisterDelete$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>): ModelsWebhookWebhookEventCreateRequestBaseResponse => r.body)
    );
  }

  /**
   * Deregister callback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4WebhooksDeregisterDelete$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4WebhooksDeregisterDelete$Xml$Response(params?: V4WebhooksDeregisterDelete$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
    return v4WebhooksDeregisterDelete$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Deregister callback.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4WebhooksDeregisterDelete$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4WebhooksDeregisterDelete$Xml(params?: V4WebhooksDeregisterDelete$Xml$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventCreateRequestBaseResponse> {
    return this.v4WebhooksDeregisterDelete$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>): ModelsWebhookWebhookEventCreateRequestBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4WebhooksCallbacktestPost()` */
  static readonly V4WebhooksCallbacktestPostPath = '/v4/webhooks/callbacktest';

  /**
   * Test event's callback.
   *
   * If the webhook callback was created with a Secret, only the UnixTimestamp property will be HMAC hashed with the secret (not the entire response payload).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4WebhooksCallbacktestPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4WebhooksCallbacktestPost$Plain$Response(params?: V4WebhooksCallbacktestPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventNotificationResponseBaseBaseResponse>> {
    return v4WebhooksCallbacktestPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Test event's callback.
   *
   * If the webhook callback was created with a Secret, only the UnixTimestamp property will be HMAC hashed with the secret (not the entire response payload).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4WebhooksCallbacktestPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4WebhooksCallbacktestPost$Plain(params?: V4WebhooksCallbacktestPost$Plain$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventNotificationResponseBaseBaseResponse> {
    return this.v4WebhooksCallbacktestPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventNotificationResponseBaseBaseResponse>): ModelsWebhookWebhookEventNotificationResponseBaseBaseResponse => r.body)
    );
  }

  /**
   * Test event's callback.
   *
   * If the webhook callback was created with a Secret, only the UnixTimestamp property will be HMAC hashed with the secret (not the entire response payload).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4WebhooksCallbacktestPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4WebhooksCallbacktestPost$Json$Response(params?: V4WebhooksCallbacktestPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventNotificationResponseBaseBaseResponse>> {
    return v4WebhooksCallbacktestPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Test event's callback.
   *
   * If the webhook callback was created with a Secret, only the UnixTimestamp property will be HMAC hashed with the secret (not the entire response payload).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4WebhooksCallbacktestPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4WebhooksCallbacktestPost$Json(params?: V4WebhooksCallbacktestPost$Json$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventNotificationResponseBaseBaseResponse> {
    return this.v4WebhooksCallbacktestPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventNotificationResponseBaseBaseResponse>): ModelsWebhookWebhookEventNotificationResponseBaseBaseResponse => r.body)
    );
  }

}
